/**
 * 响应式Hook - 基于Ant Design Grid断点系统
 * 提供统一的响应式状态管理
 */

import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export interface ResponsiveState {
  /** 当前断点状态 */
  screens: Record<string, boolean>;
  /** 是否为移动端 (<768px) */
  isMobile: boolean;
  /** 是否为平板 (768-992px) */
  isTablet: boolean;
  /** 是否为桌面 (≥992px) */
  isDesktop: boolean;
  /** 是否为大屏桌面 (≥1200px) */
  isLargeDesktop: boolean;
  /** 是否为超大屏 (≥1600px) */
  isExtraLargeDesktop: boolean;
}

/**
 * 使用响应式状态
 *
 * @example
 * ```tsx
 * const { isMobile, isDesktop } = useResponsive();
 *
 * return (
 *   <div>
 *     {isMobile && <MobileLayout />}
 *     {isDesktop && <DesktopLayout />}
 *   </div>
 * );
 * ```
 */
export const useResponsive = (): ResponsiveState => {
  const screens = useBreakpoint();

  return {
    screens,
    isMobile: !screens.md, // <768px
    isTablet: !!screens.md && !screens.lg, // 768-992px
    isDesktop: !!screens.lg, // ≥992px
    isLargeDesktop: !!screens.xl, // ≥1200px
    isExtraLargeDesktop: !!screens.xxl, // ≥1600px
  };
};

export default useResponsive;
